// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonSecondary_button___8Elv","icon":"ButtonSecondary_icon__zii4_","rightIcon":"ButtonSecondary_rightIcon__oYhxT","marketplace":"ButtonSecondary_marketplace__yZZn0"};